import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import 'es6-promise/auto'
import axios from 'axios'
// import "viewerjs/dist/viewer.css";
// import Viewer from "v-viewer";
Vue.config.productionTip = false
import vDialogs from 'v-dialogs';
Vue.use(vDialogs, { language: 'en' });

// add stylesheet
require('vue-select-image/dist/vue-select-image.css')
window.axios = require('axios')
import vSelect from 'vue-select'
import VueSelectImage from 'vue-select-image'
Vue.use(VueSelectImage)

// add stylesheet
require('vue-select-image/dist/vue-select-image.css')
import VueLazyload from 'vue-lazyload'
 
Vue.use(VueLazyload)
 
Vue.component('v-select', vSelect)
axios.defaults.baseURL = 'https://api.inguzsales.in/';

new Vue({
  vuetify,
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')